<template>
    <div>
        <nav class="side-menu">
            <ul class="side-menu-list list-unstyled">
                <template v-for="item in items">
                <li v-if="item.children" :key="item.name" :class="['with-sub', item.name === currentMenu ? 'opened' : '']" v-on:click="changeCurrentMenu(item.name)">
                    <span>
                        <a class="side-menu-list-label" href="javascript:void(0)">
                            <i v-if="item.iconClass" :class="item.iconClass">{{item.iconName}}</i>
                            <span class="lbl">{{item.name}}</span>
                        </a>
                    </span>
                    <ul class="list-unstyled">
                        <li v-for="subItem in item.children" :key="subItem.name" :class="[subItem.name == currentItem ? 'active' : '']">
                            <a :href="getRoute(subItem, item)" v-on:click="changeRoute(subItem, item)">
                                <span class="lbl">{{subItem.name}}</span>
                                <span v-if="subItem.shortcut" v-on:click="(e) => goShortcut(e, subItem)" class="add">ADD</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <li v-else :class="[item.name === currentItem ? 'active' : '']"
                    v-on:click="changeCurrentMenu(item.name)"
                    :key="item.name">
                    <a :href="getRoute(item)" v-on:click="changeRoute(item)" class="label-right">
                        <i v-if="item.iconClass" :class="item.iconClass">{{item.iconName}}</i>
                        <span class="lbl">{{item.name}}</span>
                    </a>
                </li>
                </template>
            </ul>

            <footer class="siteby">
                <a href="http://72.digital" target="_blank">
                    <img src="/img/logos/seventy-two-stacked.svg" alt="72DPI">
                    <span class="d-block">72.digital</span>
                </a>
                <p>Copyright &copy; {{ year }} 72DPI Ltd<br>  All Rights Reserved.</p>
            </footer>
        </nav>
        <div v-on:click="hide" class="sidebar-overlay"></div>
    </div>
</template>
<script>
import Vue from 'vue';
import Vuex from 'vuex';
import { singular } from 'pluralize';

export default {
    data() {
        return {
            loading: false,
            currentMenu: null,
            currentItem: null,
        }
    },

    components: {

    },

    mounted() {
        console.log('Component mounted.')
        if (this.isIE11()) {
            window.addEventListener('hashchange', this.hashChangeHandler);
        }
    },

    destroyed() {
        if (this.isIE11()) {
            window.removeEventListener('hashchange', this.hashChangeHandler);
        }
    },

    watch: {
        topLevel(newContent) {
            const type = _.get(newContent, 'type', '');
            const topic = _.chain(this.items)
                .find(item => item.type == singular(type) || _.indexOf(item.types, singular(type)) >= 0)
                .get('name', this.config(['menu', 'defaultItem'], ''))
                .value();
            this.updateTopic(topic);

            if (!this.currentMenu) {
                this.currentMenu = topic;
            }
        },
    },

    computed: {
        ...Vuex.mapGetters({
            user: 'user',
            topic: 'topic',
            content: 'content',
            parent: 'parent',
        }),

        topLevel() {
            return this.parent || this.content;
        },

        items() {
            if (!this.user) {
                return this.config(['menu', 'items'], []);
            }

            return this.getMenuItems();
        },

        year() {
            return (new Date()).getFullYear();
        },
    },

    methods: {
        ...Vuex.mapActions([
            'updateTopic', 'changeUrl',
        ]),

        changeCurrentMenu(name) {
            this.currentMenu = name;
        },

        getRoute(item, parent) {
            let path = `#/${item.route}`;

            if (_.has(item, 'query')) {
                path = `?${item.query}` + path;
            }

            return path;
        },

        changeRoute(item, parent) {
            this.currentItem = item.name;
            // return this.changeUrl(`/${item.route}`);
        },

        filterItemByPerms(item, perms) {
            const types = _.get(item, 'types', []);
            const type = _.get(item, 'type');

            const hasPermission = perms.find(([permType]) => {
                return permType == '*' || type == singular(permType) || types.indexOf(singular(permType)) >= 0
            });

            if (!hasPermission) {
                return null;
            }

            if (_.isEmpty(item.children)) {
                return { ...item };
            }

            let children = _.chain(item.children)
                .map(subItem => this.filterItemByPerms(subItem, perms))
                .reject(_.isNull)
                .value();

            return { ...item, children }
        },

        goShortcut(e, item) {
            e.preventDefault();
            e.stopPropagation();
            this.currentItem = item.name;
            return this.changeUrl(`/${item.shortcut}`);
        },

        hide() {
            document.body.classList.toggle('sidebar-show');
        },

        getMenuItems() {
            let permissions = _.get(this.user, 'role.permissions', '')
                .split(/[\,\;\|]/)
                .map(perm => _.split(perm, '.'))
                .concat([['dashboard', '*']])

            let menuItems = [];
            this.config('menu.items', [])
                .forEach(item => {
                    let parsedItem = item;

                    if (item.children) {
                        parsedItem.types = _.chain(item.children).map(subItem => subItem.type).reject(_.isUndefined).value();
                    }

                    const filteredItem = this.filterItemByPerms(parsedItem, permissions);

                    if (filteredItem) {
                        menuItems.push(filteredItem);
                    }
                })

            return menuItems;
        },

        hashChangeHandler() {
            this.$router.push(window.location.hash.substring(1, window.location.hash.length));
        },

        isIE11() {
            return !!window.MSInputMethodContext && !!document.documentMode;
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/SideNavigationComponent.vue